import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";

import errorMessageStyles from "common/components/fallbacks/error-message.styles";

const useStyles = makeStyles(errorMessageStyles);

function ErrorMessage() {
  const classes = useStyles();
  return (
    <div className={classes.message}>
      <Typography variant="h3" gutterBottom>
        Oh no
      </Typography>
      <Typography variant="h5" gutterBottom>
        There was an error on our end.
      </Typography>
      <Typography variant="h5">
        Please try again in a couple of minutes.
      </Typography>
    </div>
  );
}

export default ErrorMessage;
